/**
 * Convert path to route
 * Example: /posts/{id} -> /posts/:id
 */
function honoRouteFromPath(path) {
    return path.replace(/{/g, ':').replace(/}/g, '');
}

export { honoRouteFromPath };
